import React, { useContext } from "react";

export const ThemePreferenceContext = React.createContext();
export const useThemeContext = () => ({ ...useContext(ThemePreferenceContext) });